import { put, takeLatest, call, delay, takeEvery } from "redux-saga/effects";
import depositTutorialsService from "../../axios/services/depositTutorialsService";
import { closeTab, createTab } from "../../utils/helpers/tabHelper";
import { depositTutorialsActions, depositTutorialsyTypes } from "../actions/depositTutorialsActions";

const initialState = {
  activeTabKey: 0,
  tabs: [],
  items: [],
  tableConfig: {
    isLoading: false,
    totalData: 0,
    limit: 10,
    sort: "createdAt|desc",
    page: 1,
    filter: {
      search: ''
    }
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case depositTutorialsyTypes.LOAD_REQUESTED: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          isLoading: true,
        }
      }
    }
    case depositTutorialsyTypes.LOADED: {
      return {
        ...state,
        items: action.payload.data,
        tableConfig: {
          ...state.tableConfig,
          totalData: action.payload.data.count,
          isLoading: false,
        }
      };
    }
    case depositTutorialsyTypes.SET_TABLE_CONFIG: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          [action.key]: action.value
        }
      };
    }
    case depositTutorialsyTypes.SET_TABLE_CONFIG_FILTER: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          filter: {
            ...state.tableConfig.filter,
            [action.key]: action.value
          },
          page: 1
        }
      };
    }
    case depositTutorialsyTypes.CHANGE_TAB:
      return {
        ...state,
        activeTabKey: action.key,
      }
    case depositTutorialsyTypes.CLOSE_TAB: {
      const { newTabs, nextKey } = closeTab(state.tabs, action.key, state.activeTabKey);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: nextKey
      }
    }
    case depositTutorialsyTypes.CREATE_TAB: {
      const newTabs = createTab(state.tabs, action.key, action.title);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: action.key
      }
    }
    case depositTutorialsyTypes.GET_DETAIL_REQUESTED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) clonedTabs[action.index].loading = true;
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case depositTutorialsyTypes.GET_DETAIL_LOADED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) {
        clonedTabs[action.index].loading = false;
        clonedTabs[action.index].item = action.payload.data;
      }
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case depositTutorialsyTypes.UPDATE_SUCCESS: {
      const newTabs = state.tabs.filter((row, key) => key !== action.index);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: 0,
      }
    }
    default:
      return state;
  }
}

export function* saga() {
  yield takeLatest(depositTutorialsyTypes.LOAD_REQUESTED, function* loadData({ tableConfig }) {
    yield delay(300);
    try {
      const { data } = yield call(depositTutorialsService.list, {
        page: tableConfig.page,
        limit: tableConfig.limit,
        sort: tableConfig.sort,
      });
      yield put(depositTutorialsActions.loaded(data));
    } catch (error) {
      // console.log('error reached', error);
    }
  });

  yield takeEvery(depositTutorialsyTypes.GET_DETAIL_REQUESTED, function* getDetail({ id, index }) {
    yield delay(300);
    try {
      const { data } = yield call(depositTutorialsService.detail, id);
      yield put(depositTutorialsActions.getDetailLoaded(data, index));
    } catch (error) {
      // console.log('error reached', error);
    }
  });
}